module.exports = __webpack_public_path__ + "static/recipe.7366e7c2.png";